export default __webpack_public_path__ + "static/media/CoolAC.d1e7d929.gif";